import PropTypes from 'prop-types';

// 共通の型定義
const CourseShape = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string,
  tinyName: PropTypes.string,
  shortName: PropTypes.string,
  initialsOfSchool: PropTypes.string,
});

// 基本的な型定義
export const Courses = PropTypes.arrayOf(CourseShape);

export const Season = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string,
  published: PropTypes.bool,
});

export const SchoolStaffTypes = PropTypes.arrayOf(PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string,
  position: PropTypes.number,
  shortName: PropTypes.string,
  tinyName: PropTypes.string,
}));

export const DayLocation = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string,
  capacity: PropTypes.number,
  available: PropTypes.bool,
  openStatus: PropTypes.string,
  courses: PropTypes.arrayOf(CourseShape),
  anyNotAssigned: PropTypes.bool,
  anyCanceled: PropTypes.bool,
  anySuspended: PropTypes.bool,
  anyUnsubscribed: PropTypes.bool,
});

export const DayLocations = PropTypes.arrayOf(DayLocation);

export const Mentor = PropTypes.shape({
  id: PropTypes.number,
  fullName: PropTypes.string,
  nickname: PropTypes.string,
  season: PropTypes.string,
  gender: PropTypes.string,
  area: PropTypes.string,
  trainingCourse: PropTypes.string,
  comment: PropTypes.string,
  otherComment: PropTypes.string,
  count: PropTypes.string,
  countName: PropTypes.string,
  sameTeam: PropTypes.string,
  courses: PropTypes.arrayOf(PropTypes.string),
  courseId: PropTypes.number,
  gradeNum: PropTypes.number,
  assignedDayLocations: PropTypes.arrayOf(DayLocation),
  assignedSchoolXPrograms: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    capacity: PropTypes.number,
    courses: PropTypes.arrayOf(CourseShape),
  })),
});

export const Mentors = PropTypes.arrayOf(Mentor);

// data上ではschool_applicationであることに注意
export const Student = PropTypes.shape({
  id: PropTypes.number,
  fullName: PropTypes.string,
  grade: PropTypes.string,
  gradeNum: PropTypes.number,
  gender: PropTypes.string,
  schoolName: PropTypes.string,
  selected: PropTypes.bool,
  courseId: PropTypes.number,
  courseName: PropTypes.string,
  comment: PropTypes.string,
  assigned: PropTypes.bool,
  attendSchool: PropTypes.string,
});

export const Students = PropTypes.arrayOf(Student);

export const SchoolTeam = PropTypes.shape({
  id: PropTypes.number,
  alphabet: PropTypes.string,
  memo: PropTypes.string,
  courses: PropTypes.arrayOf(CourseShape),
  schoolStaffTypes: PropTypes.arrayOf(SchoolStaffTypes),
  mentors: PropTypes.arrayOf(Mentor),
  students: PropTypes.arrayOf(Student),
});

export const SchoolTeams = PropTypes.arrayOf(SchoolTeam);
